import moment from "moment"

/**
 * Función para determinar si el proyecto esta siendo cargado en un iframe
 */
export const isProjectLoadedInIframe = () => {
    try {
      return window.self !== window.top;
  } catch (e) {
      // Si el navegador bloquea el acceso a window.top por políticas de 
      // seguridad (Cross-Origin), sabemos con certeza que es un iframe.
      return true;
  }
}

export const getIframeTokenFromUrl = () => {
  try {
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    if (hashParams.has("tk")) {
      return hashParams.get("tk");
    }

    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("tk")) {
      return queryParams.get("tk");
    }

    return null;
  } catch (error) {
    return null;
  }
};

export const removeIframeTokenFromUrl = () => {
  try {
    const currentUrl = new URL(window.location.href);
    let shouldReplace = false;

    if (currentUrl.searchParams.has("tk")) {
      currentUrl.searchParams.delete("tk");
      shouldReplace = true;
    }

    const hashParams = new URLSearchParams(currentUrl.hash.replace(/^#/, ""));
    if (hashParams.has("tk")) {
      hashParams.delete("tk");
      currentUrl.hash = hashParams.toString() ? `#${hashParams.toString()}` : "";
      shouldReplace = true;
    }

    if (shouldReplace) {
      window.history.replaceState({}, document.title, currentUrl.toString());
    }
  } catch (error) {
    // Ignorar si no se puede actualizar la URL.
  }
};

/**
 * Función para extraer las palabras en mayúsculas de una cadena
 * @param {String} string Cadena de texto
 * @returns {Array} Array de palabras en mayúsculas
 */
export const extractWordsUpperCase = (string) => {
  const words = string.split(' ');
  
  const wordsUppercase = words.filter(word => {
      return word === word.toUpperCase();
  });
  return wordsUppercase.map(word => word.replaceAll(',', ''));
}

export const preventCloseIfNotKeyEventEsc = ($event) => {
  if ($event && ($event.keyCode  || !$event.composed)) {
    if ($event.keyCode !== 27) {
      return null
    }
    if (!$event.composed) {
      return null
    }
  }
  return true
}

// Función para formatear el precio de un servicio
export const formatCurrency = (value) => {
  if(value) {
    let sanitizedValue = String(value).replace(/[^\d,]/g, '');
    let number = parseFloat(sanitizedValue.replace(/,/g, '.'));

    if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
      return value;
    }
    if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
      return value;
    }

    return number.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
  } else {
   return value;
  }
}

export const getExtensionFileFromUrl = (url) => {
  return url
    .split(/[#?]/)[0]
    .split('.')
    .pop()
    .trim()
}

export const formatDateToHuman = (date) => {
  if (!date) return null

  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}


export const normalizeDocumentEmail = (email) => {
  if (!email || typeof email !== 'string') return ''

  const normalizedValue = email.trim().toLowerCase()
  const [username, domain] = normalizedValue.split('@')

  if (!username || !domain) {
    return normalizedValue
  }

  if (domain === 'copecflux.cl') {
    return `${username}@fluxsolar.cl`
  }

  return `${username}@${domain}`
}

export const areDocumentEmailsEquivalent = (userEmail, allowedEmail) => {
  return (
    normalizeDocumentEmail(userEmail) === normalizeDocumentEmail(allowedEmail)
  )
}

export const hasDocumentPermission = (userEmail, allowedEmails = []) => {
  if (!userEmail || !Array.isArray(allowedEmails)) return false

  return allowedEmails.some((allowedEmail) =>
    areDocumentEmailsEquivalent(userEmail, allowedEmail)
  )
}

export const isUrlValid = (urlString) => {
  try {
    const regex1Url = /^(https?:\/\/)?([\w.-]+\.[\w.-]+)$/;
    const regex2Url = /^(?:(?:https?|ftp):\/\/)(?:\w+(?::\w+)?@)?(?:[a-z0-9.-]+\.[a-z]{2,})(:[0-9]+)?(?:\/[\w.-]+)*(?:\/?|\/\?[^#]*)#?(?:fragment)?$/i;
    return regex1Url.test(urlString) || regex2Url.test(urlString);
  } catch (error) {
      return false;
  }
}

export const calculateDiferenceTwoDates = (date_start, date_end) => {
  const milisecondsPerDay = 60 * 1000

  // Parsea las fechas en formato ISO
  const dateStartFormatted = new Date(date_start);
  const dateEndFormatted = new Date(date_end);

  // Calcula la diferencia en milisegundos
  const diferenceMiliseconds = Math.abs(dateEndFormatted - dateStartFormatted);

  // Calcula el número de días y horas
  const days = Math.floor(diferenceMiliseconds / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diferenceMiliseconds % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  let minutes
  if(hours <= 0){
    minutes = Math.floor((diferenceMiliseconds % (60 * 60 * 1000)) / milisecondsPerDay);
  }

  // Crea el string de resultado
  const resultDays = `${days} Día${days !== 1 ? 's' : ''}`;
  const resultTime = hours >= 1 ? ` ${hours} Hora${hours !== 1 ? 's' : ''}` : ` ${minutes} Minuto${minutes !== 1 ? 's' : ''}` 
  
  return resultDays + resultTime;
}

export const formatDateMomentToHuman = (date) => { 
  return moment(date).format('DD/MM/YYYY');
}

export const formatDateMomentToHumanAndAddDay = (date, separator = '/') => { 
  return moment(date).add(1, 'days').format(`DD${separator}MM${separator}YYYY`);
}

// Function to return and rename a file
export const renameAndReturnNewFile = (file, newName) => {
  return new File([file], newName, { type: file.type });
}

//Formatear fecha a formato dd/mm/yyyy
export const formatDateToFormatCommon = (date) => {
  if (!date) return null
  let day = ("0" + date.getDate()).slice(-2);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let year = date.getFullYear();
  let dateFormatted = `${day}/${month}/${year}`
  return dateFormatted
}

export const formatNumberToTwoDecimals = (number) => {
  //Validar si tiene mas de dos decimales
  if (number.toString().split(".").length == 2 &&number.toString().split(".")[1].length > 2) {
    // Convertir a cadena por si el número viene como tal
    let numberStr = number.toString();
  
    // Convertir a número flotante
    let numberFloat = parseFloat(numberStr);
  
    // Validar si es un número válido
    if (isNaN(numberFloat)) {
      return 'Entrada no válida';
    }
  
    return numberFloat.toFixed(2).toString().replace('.', ',');
  }
  return number;
}

/**
 * Inserta un elemento en un array en la posición especificada
 * @param {Array} array Arreglo de objetos
 * @param {String} key Clave del objeto
 * @param {String} value Valor del objeto
 * @param {Object} newObject Objeto a insertar
 */
export const insertElementEspecificIndexArray = (array, key, value, newObject) => {
  let newArray = [...array];
  const indice = newArray.findIndex(obj => obj[key] === value);
  if (indice !== -1) {
      newArray.splice(indice + 1, 0, newObject);
  }
  return newArray;
}

export const generateRandomCode = () => {
  return Math.floor(Math.random() * 9e11 + 1e11).toString().padEnd(12, '0');
}

/**
 * Validar el formato del telefono
 * @param {Object} event Evento del teclado
 */
export const validatePhone = (event)  => {
  const allowedCharacters = /[0-9+]/;
  let textToValidate = event.key
    ? event.key
    : event.clipboardData.getData("text");
  if (!allowedCharacters.test(textToValidate)) {
    event.preventDefault();
  }
}
